import { Component, Input } from '@angular/core';
import { BaseGridFilter } from '@shared/base';

@Component({
  selector: 'gcc-grid-daterange-filter',
  templateUrl: './grid-daterange-filter.component.html',
  styleUrls: ['./grid-daterange-filter.component.scss']
})
export class GridDaterangeFilterComponent extends BaseGridFilter {
  // @ts-ignore
  @Input()  get value(): Date[] {
    return this.rangeValue;
  }
  set value(value: Date[]) {
    this.rangeValue = value;
  }

  private rangeValue = [];
  constructor() {
    super();
  }

  public onChange(value) {
    this.rangeValue = value;
    this.valueChange.emit(
      value.length === 2
        ? [new Date(new Date(value[0]).setHours(0, 0, 0, 0)), new Date(new Date(value[1]).setHours(23, 59, 59, 999))]
        : value
    );
  }
}
